import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile-testimonials',
  templateUrl: './user-profile-testimonials.component.html',
  styleUrls: ['./user-profile-testimonials.component.css']
})
export class UserProfileTestimonialsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
